import FeedVirtualized from '../../components2/Feed/FeedVirtualized';

import {
    fetchHomeFeed,
    HOME_FEED_MEDIAS_KEY
} from "../../../api/public-voissa/home-feed";
import { useInfiniteQuery, useQueryClient } from '@tanstack/react-query';
import MenuList, {MenuListGroup, MenuListItemCheck} from "../../components2/MenuList/MenuList";
import Drawer from "../../components2/Drawer/Drawer";
import {useState} from "react";
import useFilters from "../../../hooks/useFilters";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSparkles} from "@fortawesome/pro-solid-svg-icons";
import Button from "../../components2/UI/Button/Button";
import Container from '../../components2/UI/Container/Container';
import Group from '../../components2/UI/Group/Group';
import { USER_CURRENT_KEY } from '../../../api/public-voissa/users';

const filters = {
    gender : {
        multiple : true,
        uriParam : "gender",
        label : "Genre",
        defaultValue : [],
        options : [
            {
                label : "Les hommes",
                uriParam : "hommes",
                value : 1
            },
            {
                label : "Les femmes",
                uriParam : "femmes",
                value : 2
            },
            {
                label : "Les couples",
                uriParam : "couples",
                value : 3
            },
            {
                label : "Les Trans / Trav",
                uriParam : "trav-trans",
                value : 4
            }
        ]
    }
}

const HomeFeedMostRecent = ()=>{
    const explorerFilter = useFilters(filters, 'home-feed');
    const [toogleFilters, setToogleFilters] = useState(false);
    const filter = explorerFilter.apiFilter;
    const queryClient = useQueryClient();
    const dataCurrentUser = queryClient.getQueryData([USER_CURRENT_KEY]);
    const infiniteQuery = useInfiniteQuery(
        [HOME_FEED_MEDIAS_KEY, filter],
        ({pageParam = 1}) => fetchHomeFeed('recent', dataCurrentUser, {page : pageParam, ...filter}),
        {
            staleTime : (60 * 60 * 1),
            getNextPageParam: (lastPage) => {
                const nextPage = lastPage && lastPage.more ? lastPage.page + 1 : null;
                return nextPage;
            }
        }
    );

    const activeFilterCount = Object.keys(explorerFilter.apiFilter).length;
    return (
        <>
            <Container hasPadding>
                <Group right>
                    <Button small onClick={()=>setToogleFilters(!toogleFilters)} active={toogleFilters} badge={!!activeFilterCount && activeFilterCount}>
                        <FontAwesomeIcon icon={faSparkles}/> Filtres
                    </Button>
                </Group>
            </Container>
            <FeedVirtualized
                infiniteQuery={infiniteQuery}
            />
            <Drawer
                small
                open={toogleFilters}
                handleClose={()=>setToogleFilters(false)}
                headContent="Filtrer les publications"
            >
                <MenuList style={{padding:'10px'}}>
                    <MenuListGroup label={filters.gender.label}>
                        {filters.gender.options.map((option, optionIndexe) => (
                            <MenuListItemCheck key={optionIndexe} onClick={()=>explorerFilter.toggleValue('gender', optionIndexe)} active={explorerFilter.getValue('gender').includes(option.value)}>{option.label}</MenuListItemCheck>
                        ))}
                    </MenuListGroup>
                </MenuList>
            </Drawer>
        </>
    )
}

export default HomeFeedMostRecent;